module.exports = __webpack_public_path__ + "img/D1M4.26b23e2d.jpg";